import { Link } from "react-router-dom";
import NextPage from "../../components/Pagination/NextPage";
import PrevPage from "../../components/Pagination/PrevPage";
import { pagination } from "../../utils/utils";

const Pagination = (props) => {
  return (
    <ul className="pagination">
      <PrevPage activePage={props.activePage} tag={props.tag} />
      {pagination(props.activePage, props.pageCounts).map((el, i) => {
        let classActive = "";
        if (el === props.activePage) {
          classActive = "active";
        }

        return (
          <li key={i} className={classActive}>
            {el === "..." ? (
              <Link
                to={`?page=${props.activePage}${
                  props.tag ? "&tag=" + props.tag : ""
                }`}
              >
                {el}
              </Link>
            ) : (
              <Link to={`?page=${el}${props.tag ? "&tag=" + props.tag : ""}`}>
                {el}
              </Link>
            )}
          </li>
        );
      })}

      <NextPage
        activePage={props.activePage}
        pageCounts={props.pageCounts}
        tag={props.tag}
      />
    </ul>
  );
};

export default Pagination;
